//! yopu need to convert your forms ==> Formik VS React-BootStrap import { Label } from 'react-bootstrap';
import './Login.style.css';
import './Auth.style.scss';
import './Register.scss';

import React, { useEffect, useState } from 'react';
import { useNavigate, } from 'react-router-dom';

import axios from '../../Api/axios';
import useAuth from '../../hooks/useAuth';
const DemandNewPassword_URL = 'auth/demandNewPassword';
import { ArrowForward } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useRef } from 'react';
import ReactCodeInput from 'react-code-input';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { DELAY } from '../../config';
import Logo from '../../data/Logo';
import { DrawLine, ForgetPasswordSvgDraw, RightFlech } from '../../data/SVGs';
import useWindowSize from '../../hooks/useWindowSize';
//import { Form } from 'react-bootstrap';
import { PropsReactCodeInput, PropsReactCodeInputMobile } from '../../Styles/componentStyles';
import { isValidEmail } from '../../Utils/validationUtils';
import { buttonStyles, buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import NavbarHome from '../shared/Navbar/NavbarHome';
import { TextFieldComponent } from '../shared/ReusableSmallComponents';
function ForgetPassword() {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const {device}=useWindowSize();
    // const inputRefFocus = useRef(null);
    const divRef = useRef(null);
    const [width, setWidth] = useState(0);
    const { i18n } = useTranslation();
    const [enteredEmail, setEnteredEmail] = useState(false);
    const [email, setEmail] = useState('');
    const [confirmationCode, setConfirmationCode] = useState();
    const [signupErrorEmail, setSignupErrorEmail] = useState('');
    const [emailValid, setEmailValid] = useState(false);

    const demandNewPassword = async (e) => {
        e.preventDefault();
        console.log(email);
        try {
            const response = await axios.post(DemandNewPassword_URL,
                { email },
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            console.log(JSON.stringify(response?.data));
            // const accessToken = response?.data?.accessToken;
            setEnteredEmail(true);
        }
        catch (error) {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response.data?.error,
            });
        }
    };

    useEffect(() => {
        const updateWidth = () => {
            if (divRef.current) {
                const rect = divRef.current.getBoundingClientRect();
                setWidth(rect.width);
            }
        };

        // Call the function initially to set the initial width
        updateWidth();

        // Attach the event listener to update the width when the window is resized
        window.addEventListener('resize', updateWidth);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [divRef]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    const checkCodeForgetPassword = async (e) => {
        e.preventDefault();
        console.log(email, confirmationCode);
        try {
            const response = await axios.post('auth/checkCodeForgetPassword',
                { email, confirmationCode },
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            console.log(JSON.stringify(response?.data));
            const accessToken = response?.data?.accessToken;
            const roles = response?.data?.user.role;
            setAuth({ email, roles, accessToken });
            setEmail('');
            setConfirmationCode('');
            navigate('/resetPassword');
        }
        catch (error) {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response.data?.error,
            });
        }
    };
    const handlePinChange = pinCode => {
        console.log(pinCode);
        setConfirmationCode(pinCode);
    };
    useEffect(() => {
        setTimeout(() => {
            setSignupErrorEmail('');
            // clean error after shoing it
        }, DELAY);
    }, [signupErrorEmail]);

    // useEffect(() => {
    //     inputRefFocus.current.focus();
    // }, []);

    function validateEmail(email) {
        if (!isValidEmail(email)) {
            setSignupErrorEmail('email non valid');
            setEmailValid(false);
        }
        else {
            setEmailValid(true);
            setSignupErrorEmail('');
        }
    }
    //const [isFocused, setIsFocused] = useState(false);
    //const handleFocus = () => {
    //    setIsFocused(true);
    //  };

    //  const handleBlur = () => {
    //    setIsFocused(false);
    //  };

    //  const inputStyle = {
    //    // your existing styles
    //    border: `2px solid ${isFocused ? 'blue' : '#9D9E9F'}`,
    //  };
    return (
        <React.Fragment>
            <div className='HomePageInscription'>
                {device!='desktop' &&
                <NavbarHome />
                }
                {device=='desktop' &&
                <div className='FirstRectangle'>
                    <div className='LogoTitle'>
                        <div className='frame0RegisterStepOne'>
                            <Logo
                                width='198px'
                                height='54px'
                            />
                        </div>
                        <div className='frame1RegisterStepOne'>
                            <h3 className='BonjourTitle'> {i18n.t('Bonjour, connectez vous à ')}
                                <h3
                                    style={{
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        fontSize: '48px',
                                        display: 'inline',
                                        lineHeight: '56px',
                                        color: 'rgba(33, 77, 206, 1)'
                                    }}
                                >
                                    {i18n.t('High Tech Hires ')}
                                </h3>
                                {i18n.t('communauté!')}
                            </h3>
                        </div>
                    </div>

                    <div className='DrawIconeStyle'>
                        <ForgetPasswordSvgDraw />
                    </div>
                </div>
                }
                {!enteredEmail &&
                <div className='rect123434'>
                    <div className='FormForgatePass'>

                        <form
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignSelf: 'stretch',
                                gap:'24px',
                            }}
                        >
                            <h4 className='RecupererMotPass'> {i18n.t('Récupérer le mot de passe')}</h4>
                            {device!='desktop' &&
                            <ForgetPasswordSvgDraw
                                width={'100%'}
                                device={device}
                            />
                            }
                            <p className='SassisezAdressMail'>
                                {i18n.t('Saisissez l\'adresse e-mail associée à votre compte, et nous vous enverrons par e-mail un code pour réinitialiser votre mot de passe.')}
                            </p>
                            <TextFieldComponent
                                id="outlined-size-small"
                                defaultValue="Email"
                                size="small"
                                type={'text'}
                                sx={{
                                    width: '100%'
                                }}
                                label="Email"
                                name="emailForget"
                                onChange={e => {
                                    setEmail(e.target.value);
                                    validateEmail(e.target.value);
                                }}
                                value={email}
                                isInvalid={signupErrorEmail == '' ? false : true}
                                // ref={inputRefFocus}
                                focused
                            />

                            {/*</div><input
                                //    type="email"
                                //    //size='lg'
                                //    onChange={e => {
                                //        setEmail(e.target.value);
                                //        validateEmail(e.target.value);
                                //    }}

                                //    value={email}

                                //    isInvalid={signupErrorEmail == '' ? false : true}
                                //    ref={inputRefFocus}
                                ///>
                                //<Form.Text className="text-muted">
                                //    {signupErrorEmail}
                                //</Form.Text>
                                */}
                            <Button
                                type="submit"
                                variant="contained"
                                style={{...buttonStyles(),...{width: '100%'}}}
                                disabled={!emailValid}
                                onClick={(e) => {
                                    console.log(e);
                                    demandNewPassword(e);
                                }}
                            >
                                {i18n.t('Envoyer le code')}
                            </Button>
                            <div
                                className='rect127434'
                                style={{order:0}}
                            >
                                <div
                                    style={{width:'47%'}}
                                    ref={divRef}
                                >
                                    <DrawLine width={width} />
                                </div>
                                <span style={{width:'6%',textAlign:'center'}}>Ou</span>
                                <div style={{width:'47%'}}>
                                    <DrawLine width={width}/>
                                </div>
                            </div>
                            <div className='LineF2'>
                                <p className='Rappelezvous'>
                                    {i18n.t('Rappelez-vous votre mot de passe?')} &nbsp; &nbsp;</p>
                                <div className='RappelezvousBtn'>
                                    <Button
                                        style={{...buttonStyles(),...{textWrap:'nowrap'}
                                        }}
                                        variant="outlined"
                                        onClick={() => navigate('/login')}
                                        startIcon={<ArrowForward />}
                                    >
                                        {i18n.t('Se connecter')}
                                    </Button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
                }

                {enteredEmail &&
                    <div className='rect123434'>
                        <div className='FormForgatePass'>
                            <form
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignSelf: 'stretch',
                                    gap:'24px',
                                }}
                            >
                                <div className='VerifEmailCode'>
                                    <h4 className='Vemail'>{i18n.t('Vérifier l\'adresse e-mail')}</h4>
                                    <div className='codevemail'>
                                        <p className='Textcodevemail'>{i18n.t('Un message avec un code de vérification a été envoyé à votre adresse e-mail. Veuillez entrer le code pour continuer.')}</p>
                                        <div className='VemailBoxCode'>
                                            {device=='desktop' ?
                                                <ReactCodeInput
                                                    id="pinCode"
                                                    type='number'
                                                    fields={4}
                                                    value={confirmationCode}
                                                    onChange={handlePinChange}
                                                    className='reactInput'
                                                    {...PropsReactCodeInput}
                                                />
                                                :
                                                <ReactCodeInput
                                                    id="pinCode"
                                                    type='number'
                                                    fields={4}
                                                    value={confirmationCode}
                                                    onChange={handlePinChange}
                                                    className='reactInput'
                                                    {...PropsReactCodeInputMobile}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className='VerifBtnVemail'>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            style={{
                                                ...buttonStylesBlue(),...{width:'100%'}
                                            }}
                                            startIcon={<RightFlech />}
                                            onClick={(e) => {
                                                console.log(e);
                                                checkCodeForgetPassword(e);
                                            }}
                                        > {i18n.t('Vérifier')}
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                }

            </div>
        </React.Fragment>
    );
}

export default ForgetPassword;